<button class="play-button">
  <mat-icon svgIcon="play_arrow" class="white-fg mr--6"></mat-icon>
</button>